module.exports = __webpack_public_path__ + "img/grupo.6c21250c.png";